export enum ApplicationPackage {
    CMS_VOD = "cms-vod-core/",
    CMS_BAN = "cms-banner-core/",
    CMS_BTV = "cms-btv-core/",
    CMS_INGEST = "cms-ingest-service/",
    AUTH_OP = "a2srv-operation/",
    AUTH_CLIENT = "a2srv-client/",
    CRM = "crm-core/",
    CRM_CAMPAIGN = "crm-campaign/",
    PRODUCT = "crm-package/",
    SUBS = "crm-subscription/",
    ADV = "adv-core/",
    NOTIFICATION = "notification-core/",
    ENCODING = "cms-encode-new/",
    PODCAST = "podcast-manager/",
    AUTO_PROCESS = "auto-process-manager/",
    MASTER_CORE = "360-core/",
    CONTENT_VALIDATION = "content-validation/",
    CMS_BTV_ANALYTIC = "cms_btv_analytic/",
    ANALYTIC = "analytics-core/",
    POSTER_MANAGER = "poster-manager/",
    NEW_AUTH = "auth/",
}
